import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomCol, FormLabels, LanguageSelector } from 'src/components'

const BrokerageCertificateLanguage: React.FC = () => {
  const { t } = useTranslation()

  return <>
    {/* Certificate Language Field */}
    <Row>
      <CustomCol>
        <FormLabels
          title={t('admin.Brokerage.CertificateLanguage')}
          subtitle={t('admin.Brokerage.LanguageDescription')}
        />
      </CustomCol>
      <CustomCol>
        <LanguageSelector />
      </CustomCol>
    </Row>
  </>
}

export default BrokerageCertificateLanguage
